import script from "./breadcrumb.vue?vue&type=script&lang=tsx"
export * from "./breadcrumb.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__